import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid } from '@material-ui/core';
import Buttoncontrol from "../../../GeneralUI/Buttoncontrol";
import { withRouter } from 'react-router';
import { saveCustom, getDocument } from './../../../../Actions/General'
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { SnackbarProvider, withSnackbar } from 'notistack';
import { errorSetter } from '../../../../Libs/';
import AutoComplete from '../../../GeneralUI/AutoComplete';
import PSelect from '../../../GeneralUI/PSelect'
import Utils from '../../../../Libs/utils';
import CustomizedExpansionPanel from '../../../GeneralUI/PExpansionpanels';
import moment from 'moment';
import Datagrid from '../../../GeneralUI/PDatagrid/'


class UsuarioPermisos extends Component {
  state = {
    fields: {
      usuarioCodigo: null,
      usuarioNombre1: '',
      usuarioNombre2: '',
      usuarioApellido1: '',
      usuarioApellido2: '',
    },

     dataDatagridUsuarioAlmacenes: [{
      Almacen: { 'value': null, 'key': null ,'visible':true}
    }],

    dataDatagridUsuarioClientes: [{
      Cliente: { 'value': null, 'key': null ,'visible':true}
    }],

    dataDatagridUsuarioSucursales: [{
      Sucursal: { 'value': null, 'key': null ,'visible':true}
    }],

    dataDatagridUsuarioPaginas: [{
      Pagina: { 'value': null, 'key': null ,'visible':true}
    }],

    responseForm: { Message: '', typeMessage: '' }
  };

  componentDidMount = () => {
    const params = this.props.match.params;
    if (!params.id) {
      return;
    }       
  }


  cargarPermisos = async (id) => {
    if (!id) {
      return;
    }

    getDocument({
      documentId: id,
      fieldName: 'usuarioCodigo',
      moduleName: 'usuario'
    }).then(document => {
      if (!document) {
        return;
      }
      this.setState({ fields : document });

            getDocument({
              documentId: id,
              fieldName: 'usuario_codigo',
              moduleName: 'vw_usuario_almacenes_autorizados',
              isView: true,
              fields: ['almacen_codigo',
                'almacen_nombre'
              ],
              Limit: 50
            }).then(document => {
              if (!document) {
                return;
              }
                this.buildDetailUsuarioAlmacenesInterface(document);
            }).catch(ex => {
              console.log('index.jsx -- 137 > ex === ', ex);
            });

            getDocument({
              documentId: id,
              fieldName: 'usuario_codigo',
              moduleName: 'vw_usuario_sucursales_autorizadas',
              isView: true,
              fields: ['sucursal_codigo',
                'sucursal_nombre'
              ],
              Limit: 50
            }).then(document => {
              if (!document) {
                return;
              }
                this.buildDetailUsuarioSucursalesInterface(document);
            }).catch(ex => {
              console.log('index.jsx -- 137 > ex === ', ex);
            });

            getDocument({
              documentId: id,
              fieldName: 'usuario_codigo',
              moduleName: 'vw_usuario_clientes_autorizados',
              isView: true,
              fields: ['cliente_codigo',
                'cliente_razon_social'
              ],
              Limit: 50
            }).then(document => {
              if (!document) {
                return;
              }
                this.buildDetailUsuarioClientesInterface(document);
            }).catch(ex => {
              console.log('index.jsx -- 137 > ex === ', ex);
            });

            getDocument({
              documentId: id,
              fieldName: 'usuario_codigo',
              moduleName: 'vw_usuario_paginas_autorizadas',
              isView: true,
              fields: ['pagina_codigo',
                'pagina_nombre'
              ],
              Limit: 50
            }).then(document => {
              if (!document) {
                return;
              }
                this.buildDetailUsuarioPaginasInterface(document);
            }).catch(ex => {
              console.log('index.jsx -- 137 > ex === ', ex);
            });

    });

  }

  buildDetailUsuarioAlmacenesInterface = (data) => {
    let rows = data.map(row => {
      return {
        Almacen: { 'value': row.almacen_codigo, 'key': row.almacen_nombre, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioAlmacenes: rows });
  }

  buildDetailUsuarioClientesInterface = (data) => {
    let rows = data.map(row => {
      return {
        Cliente: { 'value': row.cliente_codigo, 'key': row.cliente_razon_social, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioClientes: rows });
  }

    buildDetailUsuarioSucursalesInterface = (data) => {
    let rows = data.map(row => {
      return {
        Sucursal: { 'value': row.sucursal_codigo, 'key': row.sucursal_nombre, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioSucursales: rows });
  }

    buildDetailUsuarioPaginasInterface = (data) => {
    let rows = data.map(row => {
      return {
        Pagina: { 'value': row.pagina_codigo, 'key': row.pagina_ruta, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioPaginas: rows });
  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = async (event) => {
    let { fields } = this.state;
    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }

    if (event.target.id === 'usuarioCodigo') {
      await this.cargarPermisos(fields[event.target.id]);
    }else{
      this.setState({ fields });
    }   
  }

  handleDatagrid = (data) => {
    const detalle = data.setComponente;
    switch (detalle) {
      case 'usuarioAlmacenes':
        this.setState({ dataDatagridUsuarioAlmacenes: data });
        break;
      case 'usuarioSucursales':
        this.setState({ dataDatagridUsuarioSucursales: data });
        break;
      case 'usuarioClientes':
        this.setState({ dataDatagridUsuarioClientes: data });
        break;
      case 'usuarioPaginas':
        this.setState({ dataDatagridUsuarioPaginas: data });
        break;                
      default:
        return null;
    }
  }

  save = (response) => {

    if (response.responseForm && response.responseForm.typeMessage === 'error') {
      this.setState({
        responseForm: response.responseForm
      });
    } else {
      this.setState({
        fields: response.data || this.state.fields, 
        responseForm: response.responseForm
      });
    }
    if (response.responseForm && response.responseForm.Message) {
        this.props.enqueueSnackbar(
          response.responseForm.Message,
          { variant: response.responseForm.typeMessage || 'info' }
        );
    }
  }

  handleAuto = (autoCompleteValue) => {
    this.setState({ colorAutoComplete: autoCompleteValue });
  }

  render() {
    return (
      <Paper elevation={1} className={this.props.classes.mainPaper}>

        <form className={this.props.form} onSubmit={e => e.preventDefault()}>


          <Grid container spacing={3} className={this.props.classes.gridForm}>
            <InputLabel className={this.props.classes.tittleLabelForm}>
               Usuario Permisos.
            </InputLabel>
          </Grid>

          <Grid container spacing={2}> 
              <Grid item xs={3} className={this.props.classes.gridForm}>            
                <AutoComplete
                  id="usuarioCodigo"
                  tableName='usuario'
                  fields={['usuarioCodigo', 'usuarioNombreCompleto']}
                  aliases={[{ value: 'ID', size: 1 }, { value: 'Nombre', size:11 }]}
                  size='xx'
                  primaryField='usuarioCodigo'
                  searchField='usuarioNombreCompleto'
                  placeHolder='Seleccionar Usuario'
                  onSelect={this.handleChange}
                  value={this.state.fields["usuarioCodigo"]} 
                />
              </Grid>              
          </Grid>

          <Grid>
            <CustomizedExpansionPanel tittle="PERMISOS X ALMACEN +++">
              <Datagrid datosHeader={this.state.fields} dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioAlmacenes} setComponente="usuarioAlmacenes" />
            </CustomizedExpansionPanel>
          </Grid>

          <CustomizedExpansionPanel tittle="PERMISOS X CLIENTE +++">
              <Datagrid datosHeader={this.state.fields} dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioClientes} setComponente="usuarioClientes"  />
          </CustomizedExpansionPanel>

          <Grid>
            <CustomizedExpansionPanel tittle="PERMISOS X SUCURSAL +++">
              <Datagrid datosHeader={this.state.fields} dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioSucursales} setComponente="usuarioSucursales"  />
            </CustomizedExpansionPanel>
          </Grid>

          <CustomizedExpansionPanel tittle="PERMISOS X PAGINA +++">
              <Datagrid datosHeader={this.state.fields} dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioPaginas} setComponente="usuarioPaginas"  />
          </CustomizedExpansionPanel>    

        </form>
        <div>
        <Buttoncontrol
            saveData={this.state}
            saveDataValidation={this.state.fields}
            moduleName='Usuario'
            save={this.save}
            messageValidation={this.messageValidation}
            primaryFields={['usuarioCodigo']}
            formValidations={this.state.formValidations}
            errorHandler={this.setErrors}
            url='/processes/usuario_permisos'
            isFormLite={true}
          /></div>
      </Paper>
    );
  }
}

UsuarioPermisos.propTypes = {
  onClick: PropTypes.func.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(UsuarioPermisos)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={1}
      action={[
        <Button variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}

    >
      <MyApp />
    </SnackbarProvider>
  );
}

export default IntegrationNotistack;